import React from 'react';
import PropTypes from 'prop-types';
import { Col, Container, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { clientOnly } from 'utils/react';
import WebsiteTable from './WebsiteTable';
import classes from './Dashboard.scss';

class Unlaunched extends React.Component {
  static propTypes = {
    siteCount: PropTypes.number.isRequired,
    unlaunchedSites: PropTypes.array.isRequired,
  };

  renderTableTitle() {
    const tooltip = (
      <Tooltip id="unlaunched-website-tooltip">
        An "unlaunched website" is a website that does not have a primary domain.
      </Tooltip>
    );

    return (
      <span>
        Unlaunched Websites
        {' '}
        <OverlayTrigger
          placement="right"
          overlay={tooltip}
        >
          <i className="fa fa-question-circle text-muted" />
        </OverlayTrigger>
      </span>
    );
  }

  render() {
    // Chart.js requires the window to be present to work properly, so we can't import this
    // up above or bad server-side rendering things happen
    const DoughnutChart = require('react-chartjs-2').Doughnut; // eslint-disable-line global-require

    const { siteCount, unlaunchedSites } = this.props;

    return (
      <Container fluid className={classes.padTop}>
        <Row>
          <Col md={6}>
            <DoughnutChart
              data={{
                labels: ['Launched Websites', 'Unlaunched Websites'],
                datasets: [{
                  data: [siteCount - unlaunchedSites.length, unlaunchedSites.length],
                  backgroundColor: [
                    '#2ba7df',
                    '#8fc83c',
                  ],
                  hoverBackgroundColor: [
                    '#2ba7df',
                    '#8fc83c',
                  ],
                }],
              }}
            />
          </Col>
          <Col md={6}>
            <WebsiteTable
              title={this.renderTableTitle()}
              websites={unlaunchedSites}
            />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default clientOnly()(Unlaunched);
